import { Type } from 'class-transformer';
import { IsNotEmptyObject, ValidateIf, ValidateNested } from 'class-validator';

import { NotificationTypeDto } from './notification-type.dto';

export class NotificationSubscriptionsDto {
  /** Shipment updates (Backstage and email). */
  @ValidateIf((_, value) => value !== undefined)
  @IsNotEmptyObject()
  @ValidateNested()
  @Type(() => NotificationTypeDto)
  orderShipment?: NotificationTypeDto;

  /**
   * Order updates. `email` is monthly orderbook overview; `push` is per-line changes in Backstage.
   */
  @ValidateIf((_, value) => value !== undefined)
  @IsNotEmptyObject()
  @ValidateNested()
  @Type(() => NotificationTypeDto)
  orderUpdates?: NotificationTypeDto;
}
